import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';

import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import AssetsIcon from '../../../assets/images/oparation.svg';
import AssetsIconw from '../../../assets/images/oparation_a.svg';
import Acceptance from './Components/Acceptance';
import InStock from './Components/ExportInStock';
import OutBound from './Components/OutBound';

const Export = () => {
  const keysToRemove = ['Ftab_inbound', 'Ftab_planning', 'Ftab_import', 'Ftab_shprec'];
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });
  const initialTab = localStorage.getItem("Ftab_export") || 'acceptance';
  const isMounted = useRef(false);
  const [selectedButton, setSelectedButton] = useState(initialTab);
  const [apiNumber, setApiNumber] = useState(null);
  const [msgCount, setMsgCount] = useState();

  useEffect(() => {
    setSelectedButton(initialTab);
  }, [initialTab]);
  // console.log('555', selectedButton);
  const handleButtonClick = (button) => {
    setSelectedButton(button);
    localStorage.setItem('Ftab_export', button);
  };

  return (
    <>
      <div className="">
        <Header page_type='fsm' logo_url='/ForwarderShipments/Export' />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel">
            <div className="mainTab">
              <TopMenu module='FSHPMNGR' />
              <div className="">
                <div className="allcontent-fl">
                  <div className='d-flex justify-content-between mb-3'>
                    <div>
                      <button className={selectedButton === 'acceptance' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('acceptance')}>
                        <img src={selectedButton === 'acceptance' ? AssetsIconw : AssetsIcon} /> <span>Acceptance</span>
                      </button>
                      <button className={selectedButton === 'instock' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('instock')}>
                        <img src={selectedButton === 'instock' ? AssetsIconw : AssetsIcon} /> <span>In Stock</span>
                      </button>
                      <button className={selectedButton === 'outbound' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('outbound')}>
                        <img src={selectedButton === 'outbound' ? AssetsIconw : AssetsIcon} /> <span>Outbound</span>
                      </button>
                    </div>
                    <div className='search'>
                      <div className="form-group has-search">

                        {/* <ReactSearchAutocomplete
                                                    items={searchItems}
                                                    onSearch={handleOnSearch}
                                                    onHover={handleOnHover}
                                                    onSelect={handleOnSelect}
                                                    onFocus={handleOnFocus}
                                                    autoFocus
                                                    placeholder="Search ULD"
                                                // formatResult={formatResult}
                                                /> */}
                      </div>
                    </div>
                  </div>
                  <div className="lcontent">
                    {selectedButton === 'acceptance' && <Acceptance />}
                    {selectedButton === 'instock' && <InStock />}
                    {selectedButton === 'outbound' && <OutBound />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Export